import { EmailValidationResultDto } from './email-validation-result-dto';
import { getApiUrl } from './url-helpers';
import axios from 'axios';

export async function validateEmail(email: string): Promise<EmailValidationResultDto> {
  const response = await axios.get<EmailValidationResultDto>(getApiUrl('api', 'v1', 'emailvalidation', email));
  return response.data;
}
